import { Subject } from 'rxjs';
import { Gizmo } from '../../gizmos';
import {
  IGizmoData,
  ILocationData,
  ISingleFeature,
  TGizmoData,
} from '../../types';
import CommonBinder from '../common-binder';

class LocationFieldBinder extends CommonBinder {
  public locations: Subject<ILocationData[]>;

  constructor(gizmo: Gizmo) {
    super(gizmo);

    this.locations = new Subject<ILocationData[]>();
    this._gizmo.data.subscribe((data: TGizmoData) => {
      if (
        data &&
        !Array.isArray(data) &&
        typeof data.v === 'object' &&
        !(data.v instanceof Date) &&
        data.v.latitude
      ) {
        this.locations.next([data.v]);
      } else if (data === undefined) {
        this.locations.next([]);
      }
    });
  }

  public init = async () => {
    const config = this._gizmo.getConfig();

    if (config.ops?.locationField?.limit?.isLimited) {
      const features: ISingleFeature[] = [
        {
          path: 'locationField.isLimited',
          value: true,
        },
      ];
      if (config.ops.locationField.limit.radius !== undefined) {
        features.push({
          path: 'locationField.limitRadius',
          value: config.ops.locationField.limit.radius,
        });
      } else {
        features.push({
          path: 'locationField.limitRadius',
          value: 100,
        });
      }

      this._gizmo.setFeatures({
        singleFeatures: features,
      });
    } else {
      this._gizmo.setFeatures({
        singleFeatures: [
          {
            path: 'locationField.isLimited',
            value: false,
          },
        ],
      });
    }
  };

  /**
   * Set a single location on the gizmo data
   * @param {ILocationData} location location to be set
   */
  public setLocation = async (location?: ILocationData) => {
    if (location) {
      await this._gizmo.setData({ v: location });
    } else {
      await this._gizmo.setData(undefined);
    }
  };

  public getLocations = (): ILocationData[] => {
    const locations: ILocationData[] = [];
    const data = this._gizmo.getData() as IGizmoData;

    if (
      data &&
      !Array.isArray(data) &&
      typeof data.v === 'object' &&
      !(data.v instanceof Date) &&
      data.v.latitude
    ) {
      locations.push(data.v);
    }

    return locations;
  };
}

export default LocationFieldBinder;
